<template>
  <div class="columns is-mobile">
    <div class="column dashboard__menu">
      <div class="sidebar sidebar--static">
        <div class="inner">
          <ul class="sidebar-menu">
            <li title="Quản lý phòng họp">
              <router-link
                :to="'/ongoing-conference-list'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-conf_control.png" alt="Quản lý phòng họp">
                <span class="is-block polycom-link-text">Quản lý phòng họp</span>
              </router-link>
            </li>
            <li title="Quản lý người dùng">
              <router-link
                :to="'/user-management'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-address.png" alt="Quản lý người dùng">
                <span class="is-block polycom-link-text">Quản lý người dùng</span>
              </router-link>
            </li>
            <li title="Tạo lịch họp">
              <router-link
                :to="'/calendar'"
                class="polycom-link is-active">
                <img src="@/assets/images/icons/icon-schedule.png" alt="Tạo lịch họp">
                <span class="is-block polycom-link-text">Tạo lịch họp</span>
              </router-link>
            </li>
            <li title="Lọc người tham gia phòng họp">
              <router-link
                :to="'/passcode-room-management'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-reservation.png" alt="Lọc người tham gia phòng họp">
                <span class="is-block polycom-link-text">Lọc người tham gia phòng họp</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="column content-management">
      <div class="breadcrumb-wrapper">
        <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li><router-link to="/index">Trang chủ</router-link></li>
            <li class="is-active"><a>Tạo lịch họp</a></li>
          </ul>
        </nav>
      </div>
      <div id="sendMail">
      
        <div class="columns is-one-thirds is-multiline">
          <div class="column" >
            <b-datepicker 
            v-model="date" 
            :events="eventsCalendar"
            inline> </b-datepicker>
          </div>
          

          <div class="column is-three-fifths column-second">

            <div class="title is-4 titile-date">
              {{date | moment("dddd, Do/MM/YYYY") }} 
            </div>

            <div class="title is-4 color-primary-2 title-calendar">Lịch họp</div>
            <div class="table-events--detail">
              <table v-if="Object.keys(filterdEvents).length" class="table-events">
                <thead>
                  <tr>
                    <th>Thời gian</th>
                    <th>Chủ đề</th>
                    <th>Url</th>
                    <!--<th></th>-->
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                  v-for="(event, index) in filterdEvents"
                  :key="index"
                  :class="{selected: selectedEvent === event}"
                  @click="clickEvent(event)"
                  >
                    <td>{{ niceTime(event.start) }} - {{ niceTime(event.end ) }}</td>
                    <td>{{event.title}}</td>
                    <td><a target="_blank" :href="`https://vvcroom-mea.viettel.vn/${event.eventId}`">https://vvcroom-mea.viettel.vn/{{event.eventId}}</a></td>
                    <!--<td><b-button type="is-info" size="is-small" @click="updateEventChange(event)">Thay đổi</b-button></td>-->
                    <td><b-button type="is-danger" size="is-small" @click="promptToDelete(event._id)">Xoá sự kiện</b-button></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <br>
            <div>
              <a @click="openConfCalendarModal" class="add-user-block add-user-block--calendar">
                <b-icon
                  icon="plus-circle"
                  size="is-midium"
                  pack="fas"
                  class="add-user-block__icon color-primary-2"
                ></b-icon>
                <span class="color-primary-2">Thêm lịch họp mới</span>
              </a>
            </div>
          </div>
        </div>


        <!-- Popup event -->

        <b-modal :active.sync="isAddEventActive" :width="640" scroll="keep" @close="isAddEventActive = false" class="modal--add-event">
          <div>
            <header class="modal-card-head"><p class="modal-card-title">Thêm lịch họp mới</p><button aria-label="close" class="delete" @click="isAddEventActive=false"></button></header>
              <div class="card padding_2rem modal--add-event-content">
              <form @submit.prevent="validateBeforeAddEvent('formAdd')" data-vv-scope="formAdd">
                <div>
                  <b-field label="Ngày họp" custom-class="has-text-weight-normal body-text">
                    <b-datepicker
                      pack="fas"
                      v-model="eventInput.date"
                      name="date"
                      icon="calendar-alt"
                      ref="datePicker"
                      class="custom-control"
                      data-vv-as="Ngày họp"/>
                  </b-field>
                </div>

                <div class="columns mt-5">
                  <div class="column">
                    <b-field
                      label="Bắt đầu"
                      custom-class="has-text-weight-normal body-text">
                      <b-timepicker
                        rounded
                        icon="clock"
                        pack="fas"
                        v-model="eventInput.start"
                        name="start"
                        :hour-format="hourFormat" ref="startDatePicker"
                        class="custom-control"
                        data-vv-as="Bắt đầu"/>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="Kết thúc" custom-class="has-text-weight-normal body-text">
                      <b-timepicker
                        rounded
                        icon="clock"
                        pack="fas"
                        v-model="eventInput.end"
                        name="end"
                        :hour-format="hourFormat" ref="endDatePicker"
                        class="custom-control"
                        data-vv-as="Kết thúc"/>
                    </b-field>
                  </div>
                </div>

                <div>
                  <b-field
                    :type="{'is-danger': errors.has('room')}" :message="errors.first('room')" custom-class="has-text-weight-normal body-text">
                      <template slot="label">
                        ID phòng họp <span class="has-text-danger">*</span>
                      </template>
                      <div v-if="roomList && Object.keys(roomList).length" class="block">
                        <b-radio 
                          v-model="eventInput.room" 
                          v-validate="'required'"
                          name="room"
                          v-for="room in roomList"
                          :key="room.roomIdentifier"
                          :native-value="room.roomIdentifier"
                          class="mr-20 mb-10"
                          data-vv-as="ID phòng họp">
                          {{room.roomIdentifier}}
                        </b-radio>
                        <div class="help is-danger">{{errors.first('formAdd.room')}}</div>
                      </div>
                      <div v-else class="block">
                        <p style="color:red">*Vui lòng liên hệ để tạo phòng họp:  
                        <router-link
                          :to="'/contact'"
                          style="color:red"
                          class="polycom-link">
                          click here
                        </router-link>
                        </p>
                      </div>
                  </b-field>
                </div>
                <div class="mt-10">
                  <b-field
                    :type="{'is-danger': errors.has('formAdd.title')}"
                    :message="errors.first('formAdd.title')" custom-class="has-text-weight-normal body-text">
                    <template slot="label">
                      Chủ đề <span class="has-text-danger">*</span>
                    </template>
                    <b-input
                      v-model="eventInput.title"
                      name="title"
                      v-validate="'required'"
                      data-vv-as="Chủ đề"/>
                  </b-field>
                </div>
                <div class="mt-20">
                  <button
                    class="is-centered button is-info conference__eventId__button" @click.prevent="getConferenceId">Lấy id cuộc họp</button> <span class="conference__eventId body-text">ID <span class="has-text-danger">*</span> {{eventId}}</span>
                  <b-input
                    v-model="eventId"
                    name="roomID"
                    v-validate="'required'"
                    class="is-hidden"
                    data-vv-as="Id cuộc họp"/>
                  <div class="help is-danger">{{errors.first('formAdd.roomID')}}</div>
                </div>
                <div class="mt-20">
                  <b-field
                    custom-class="has-text-weight-normal body-text"
                    :type="{'is-danger': errors.has('formAdd.email')}">
                    <template slot="label">
                      Thành phần tham dự <span class="has-text-danger">*</span>
                    </template>
                    <div class="block">
                      <p>(Nhấn phím 'Enter' để điền nhiều email)</p>
                      <b-taginput
                        v-model="eventInput.email"
                        ellipsis
                        name="email"
                        v-validate="'required|email'"
                        data-vv-as="Thành phần tham dự"
                        >
                      </b-taginput>
                    </div>
                  </b-field>
                  <div class="help is-danger">{{errors.first('formAdd.email')}}</div>
                </div>
                <div class="mt-20">
                  <b-field
                    label="Nội dung"
                    custom-class="has-text-weight-normal body-text">
                      <b-input 
                      id="mailMessage"
                      v-model="eventInput.message"
                      maxlength="200" type="textarea"></b-input>
                  </b-field>
                </div>
                <div class="has-text-centered mt-15">
                  <button
                    type="submit" 
                    class="is-centered button is-info"
                    :class="{'is-loading': isLoaded}"
                    :disabled="isLoaded"
                    >Tạo lịch họp</button>
                </div>
              </form>
              </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>

  
</template>

<script>
import SendMail from "@/services/SendMail";
import { mapState, mapActions } from "vuex";

export default {
  name: 'Schedule',
  computed: {
    ...mapState('calendar', ['events', 'searchEvents', 'conferenceId']),
    ...mapState("room", ["roomList"]),
    ...mapState("participant", ["userList"]),

    filterdEvents:  function () {
      let self = this;
      let evs = this.events.filter(function(o) {
        return self.formatDate(o.date) == self.formatDate(self.date)
      });
      return evs;
    },
    eventsCalendar: function() {
      let arr = [...this.events];
      arr.forEach(item => {
        item.date = new Date(item.date)
      });
      return arr
    }

  },
  created() {
    this.fetchEvents()
    this.$store.dispatch("room/getRooms", this.$store.state.auth.username);
  },
  data() {
    return {
      
      email: [],

      roomId: localStorage.roomId || " ",

      date: new Date(),
      isAddEventActive: false,
      isAddUpdateEventActive: false,
      hourFormat: "12",


      eventInput: {
        date: new Date(),
        message: "",
        title: "",
        email: [],
        start: new Date(),
        end: new Date(),
        room: null,
      },

      eventChange: {},

      isLoaded: false,
      selectedEvent: {
        date: new Date(),
        message: "",
        title: "",
        email: [],
        start: new Date(),
        end: new Date(),
        room: "",
      },

      host: "",

      emailList: [],
      emailListModify: [],

      eventId: "",
      confId: ""

    }
  },
  methods: {
    ...mapActions('calendar', ['addEvent','removeEvent', 'updateEvent', 'setSearchEvents', 'createEvent', 'fetchEvents', 'getConference']),
    ...mapActions("participant", [ "getParticipants"]),
    clickEvent(event) {
      this.selectedEvent = event;
    },
    coverStringToArray(txt) {
      if(txt && (typeof txt) == "string") return txt.split(",")
      else return []
    },
    

    updateEventChange(event) {
      event.date = new Date(event.date)
      event.start = new Date(event.start)
      event.end = new Date(event.end)
      event.email = this.coverStringToArray(event.email)

      this.eventChange = event;
      
      this.isAddUpdateEventActive = true
    },

    validateBeforeAddEvent(scope) {
      let self = this;

      this.isLoaded = true;
      
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          self.eventInput.eventId = self.eventId;
          self.eventInput.confId = self.confId;

          const end = self.$moment(self.eventInput.date).format().split('T')[0]+'T'+self.$moment(self.eventInput.end).format().split('T')[1];
          const start = self.$moment(self.eventInput.date).format().split('T')[0]+'T'+self.$moment(self.eventInput.start).format().split('T')[1];

          self.createEvent({...self.eventInput, start, end}).then(() => {
            self.isAddEventActive = false

            self.$nextTick(() => {
              self.errors.clear();
              self.$nextTick(() => {
                self.eventInput = {
                  date: new Date(),
                  title: "",
                  email: [],
                  message: "",
                  start: new Date(),
                  end: new Date()
                }
                self.$validator.reset();
              });
            });
            let evnetSend = self.eventInput;
            evnetSend.date = self.niceDate(self.eventInput.date);

            evnetSend.start = start;
            evnetSend.end = end;

            SendMail.sendMail({
              mailfrom: localStorage.username,
              event: evnetSend
              
            }).then(res => {
              self.$toast.open({
                message: res.data.mes,
                type: "is-info",
                position: "is-top",
                duration: 3000
              });
            })
          }).finally(() => {
            this.isLoaded = false;
          });

          return;
        } 
        this.isLoaded = false;
      });
    },
    validateBeforeUpdateEvent(scope) {
      let self = this;
      this.isLoaded = true;
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          self.updateEvent(self.eventChange).then(() => {
            self.isAddUpdateEventActive = false

            self.$nextTick(() => {
              self.errors.clear();
              self.$nextTick(() => {
                self.eventChange = {
                  date: new Date(),
                  host: "",
                  title: "",
                  start: new Date(),
                  end: new Date()
                }
                self.$validator.reset();
              });
            });

            SendMail.sendMail({
              mailfrom: localStorage.username,
              event: {
                date: self.niceDate(self.eventChange.date),
                message: self.eventChange.message,
                room: self.eventChange.room,
                // end: self.niceTime(self.eventChange.end),
                // start: self.niceTime(self.eventChange.start),
                end: self.$moment(self.eventInput.date).format().split('T')[0]+'T'+self.$moment(self.eventInput.start).format().split('T')[1],
                start: self.$moment(self.eventInput.date).format().split('T')[0]+'T'+self.$moment(self.eventInput.end).format().split('T')[1],
                title: self.eventChange.title,
                email: self.eventChange.email
              }
              
            }).then(res => {
              self.$toast.open({
                message: res.data.mes,
                type: "is-info",
                position: "is-top",
                duration: 3000
              });
            })
            
          }).finally(() => {
            this.isLoaded = false;
          });
          
          
        }
       
      });
    },

    promptToDelete(id){
      let self = this;
      this.$dialog.confirm({
        message: '<span class="body-text">Bạn có chắc chắn xoá không!</span>',
        onConfirm: () => {
          self.removeEvent(id).then(() => {
            this.$toast.open('Sự kiện đã được xoá')
          })
        },
        cancelText: 'Đóng'
      })
    },

    formatDate(date) {
      return this.$moment(date).format("dddd, MMMM Do YYYY")
    },
    niceTime(date) {
      return this.$moment(date).format("h:mm a").replace(" ch", "pm").replace(" sa", "am")
    },

    niceDate(date) {
      return this.$moment(date).format("dddd, Do/MM/YYYY")
    },
    getConferenceId() {
      this.$validator.validate('formAdd.room')
      this.$validator.validate('formAdd.title')
      if(this.eventInput.date && this.eventInput.title && this.eventInput.start && this.eventInput.end && this.eventInput.room) {
         const data = {
            username: this.$store.state.auth.username,
            event: {
              title: this.eventInput.title,
              startTime: this.$moment(this.eventInput.date).format().split('T')[0]+'T'+this.$moment(this.eventInput.start).format().split('T')[1],
              endTime: this.$moment(this.eventInput.date).format().split('T')[0]+'T'+this.$moment(this.eventInput.end).format().split('T')[1],
              room: this.eventInput.room
            }
          }
          this.getConference(data).then(res => {
            if(res.data.status) {
              this.eventId = res.data.eventId
              this.confId = res.data.confId
              this.$toast.open({
                message: "Thành công!",
                type: "is-info",
                position: "is-top",
                duration: 2000
              });
              this.eventInput.message += 'https://vvcroom-mea.viettel.vn/' + res.data.eventId
            } else {
              this.$toast.open({
                message: res.data.message,
                type: "is-danger",
                duration: 2000
              });
            }
          })
      }
    },
    openConfCalendarModal() {
      this.isAddEventActive = true
      // this.$nextTick(() => {
      //   this.$refs.startDatePicker.$el.querySelector('.control').classList.replace('has-icons-left', 'has-icons-right')
      //   this.$refs.endDatePicker.$el.querySelector('.control').classList.replace('has-icons-left', 'has-icons-right')
      //   this.$refs.datePicker.$el.querySelector('.control').classList.replace('has-icons-left', 'has-icons-right')
      //   this.$refs.datePicker.$el.querySelector('.icon').classList.replace('is-left', 'is-right')
      //   this.$refs.startDatePicker.$el.querySelector('.icon').classList.replace('is-left', 'is-right')
      //   this.$refs.endDatePicker.$el.querySelector('.icon').classList.replace('is-left', 'is-right')
      // })
    }

  },
  mounted() {
    this.getParticipants(this.$store.state.auth.entityTag);
  }
}
</script>

<style lang="scss" scope>
  .padding_2rem {
    padding: 2rem;
  }
  .mt-15 {
    padding-top: 0.75rem;
  }
  .titile-date {
    text-align: center;
    font-size: 1.7rem;
    color: #000;
    font-family: "segoeuib", Helvetica, sans-serif;
  }
  .titile-date::first-letter {
     text-transform: uppercase;
  }
  
  .add-user-block {
    display: inline-flex;
  }
  .table-events {
    width: 100%;
    border-collapse: separate; 
    border-spacing: 0 5px; 

    &--detail {
      margin-right: 10px;
    }

    thead {
      th {
        font-weight: bold;
        padding: 5px;
      }
    }
    tbody {
      tr:hover {
        cursor: pointer;
      }
      td {
        background: #f1f0f0;
        padding: 5px;
      }
      .selected {
        td {
          background: #f8f0f0
        }
      }
    }
  }
  #sendMail {
    .form-send-mail {
      max-width: 100%;
      padding: 20px 60px;
    }
  }
  #sendMail .b-checkbox.checkbox + .checkbox {
    margin-left: 1rem;
  }
  .taginput {
    height: auto !important;
  }
  .select:not(.is-multiple):not(.is-loading)::after {
    margin-top: -10px;
  }
  .column {
    > .datepicker {
      &.control {
        margin-left: 40px;
      }
    }
  }
  .conference__eventId__button {
    vertical-align: middle;
  }
  .conference__eventId {
    vertical-align: middle;
    margin-left: 10px;
  }
  .column-second {
    padding-left: 40px;
  }
  .modal--add-event {
    .modal-content {
      overflow: visible;
    }
    &-content {
      overflow: auto;
      max-height: calc(100vh - 80px);
    }
  }
  .dial-type {
    .select select:not([multiple]) {
      height: 40px;
    }
  }
  .b-radio.radio + .radio {
    margin-left: 0;
  }
</style>